import { EventController } from './base';
import ReactDOM from 'react-dom';
import AddEditLesson, {
  ModuleInstance,
  Supersource,
  FileInfo,
  SubsourceInfo,
  CarryoverModuleInstance,
} from '../components/AddEditLesson';
import React from 'react';

interface TeacherInfo {
  id: number;
}

export default class ModuleBundlesController extends EventController {
  static targets = ['render', 'teacherSelect'];

  renderTarget: HTMLElement;
  missingStudyPeriodWarningTarget: HTMLElement;
  teacherSelectTarget: HTMLSelectElement;
  studentId: string;

  connect() {
    console.log('Connected');
    this.studentId = JSON.parse(this.data.get('studentId'));
    const supersources: Supersource[] = JSON.parse(this.data.get('supersources'));
    const userFiles: FileInfo[] = JSON.parse(this.data.get('userFiles'));
    const regularTeachers = JSON.parse(this.data.get('regularTeachers'));

    const defaultSupersourceId = supersources.find(supersource => supersource.name.toLowerCase().includes('allset'))?.id;

    const moduleInstances: ModuleInstance[] = JSON.parse(this.data.get('moduleInstances'));

    const defaultSubsourcesData: SubsourceInfo[] = JSON.parse(this.data.get('defaultSubsources'));
    const carryoverModuleInstances: CarryoverModuleInstance[] = JSON.parse(this.data.get('carryoverModuleInstances'));
    const isNew: boolean = JSON.parse(this.data.get('isNew'));
    const overrideFormName: string = this.data.get('overrideFormName');
    // use React to do most of the interactive rendering
    ReactDOM.render(React.createElement(AddEditLesson, {
      supersources,
      userFiles,
      isNew,
      carryoverModuleInstances,
      defaultSubsourcesData,
      moduleInstances,
      defaultSupersourceId,
      overrideFormName,
      studentId: undefined,
    }), this.renderTarget);
  }
}
